<div>
    <kl-description-list>
        <kl-description-list-row>
            <vl-u-spacer mod-small />
            <kl-contact-card :title="athumiOrganisation" :subtitle="athumiOrganisationVat" :address="athumiOrganisationContactAddress" />
            <template v-if="showEmail">
                <vl-link v-if="hasAthumiId" :href="`mailto:${email}`" icon="mail" mod-icon-before >{{ email }}</vl-link>
            </template>
            <vl-action-group>
                <vl-button tag-name="a" @click.prevent="editActor" mod-link>
                    <template v-if="hasAthumiId">Actor aanpassen</template>
                    <template v-else>Actor aanmaken</template>
                </vl-button>
            </vl-action-group>
        </kl-description-list-row>
    </kl-description-list>

    <vl-modal :id="editActorModal" :closable="true" mod-medium>
        <form class="vl-form" @submit="onSubmit">
            <vl-title tag-name="h3">
                <template v-if="hasAthumiId">Actor aanpassen <small>({{athumiOrganisation}})</small></template>
                <template v-else>Actor aanmaken <small>({{athumiOrganisation}})</small></template>
            </vl-title>
            <vl-u-spacer mod-small />
            <vl-form-grid mod-stacked>
                <vl-column width="8">
                    <kl-field-validation-wrapper-yup :field="fields.vatNumber" #default="{hasErrors}" mod-required>
                        <vl-input-field name="KBO-nummer" :mod-disabled="!noVatNumberPresent" id="vatNumber" v-model="vatNumber" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="4"></vl-column>
                <vl-column v-if="showEmail" width="8">
                    <kl-field-validation-wrapper-yup :field="fields.emailAddress" #default="{hasErrors}" annotation="Vul hier een algemeen e-mailadres in waarop de organisatie facturatie wenst te ontvangen." mod-required>
                        <vl-input-field name="e-mailadres" id="email-address" v-model="email" autocomplete="on" placeholder="Facturatie e-mailadres" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="12">
                    <vl-title tag-style="h6">Maatschappelijke zetel</vl-title>
                    <kl-address-form ref="addressForm" v-model="actorAddress" :form-path="fields.actorAddress.path" />
                    <vl-u-spacer />
                </vl-column>
                <vl-action-group>
                    <vl-button type="submit" mod-large :mod-disabled="disableSubmit" :mod-loading="isSending">Wijzigingen opslaan</vl-button>
                    <vl-button type="button" mod-link @click="cancelEdit"
                               v-vl-modal-toggle="'edit-actor-modal'" icon="cross" mod-icon-before>Annuleer</vl-button>
                </vl-action-group>
            </vl-form-grid>
        </form>
    </vl-modal>
</div>
